import { useState } from "react";
import { useMutation } from "@apollo/client/react";
import { ADD_TENANT } from "@/hooks";
import type { AddTenantMutation } from "@/types/graphql";

type AddTenantResponse = {
  addTenant: AddTenantMutation;
};

export const useAddTenant = (
  onCompleted: () => void = () => {},
  onError: (_error: string) => void = (_error) => {},
) => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [addTenant, { loading, data }] = useMutation<AddTenantResponse>(
    ADD_TENANT,
    {
      onCompleted: (response) => {
        if (response.addTenant?.success) {
          setSuccess(true);
          setResetForm(true);
          setTimeout(() => {
            setSuccess(false);
            setResetForm(false);
          }, 5000);
          onCompleted();
        } else {
          setSuccess(false);
        }
      },
      onError: ({ message }) => {
        setSuccess(false);
        onError(message);
      },
      refetchQueries: ["getTenantsList"],
    },
  );
  return {
    addTenant,
    loading,
    success,
    data,
    resetForm,
  };
};
